import React, { Component } from "react";
import axios from "axios";
import Empty from "../../image/empty.svg"
import TutorDashMenu from "../../part/tutor_dash_menu";
import FilterCourse from "../../part/filter_bar_course";
import FooterDashboard from "../../part/footer.dashboard";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";
import { Link } from "react-router-dom";
import LoadingError from "../../part/loading_error";
import Navigate from "../../part/navigationComponent";
// import FloatingContact from "../../part/floating.contact";


class TutorCourses extends Component {
    state = {
        filter_type_name: "Type",
        filter_level_name: "Level",
        filter_status_name: "Status",
        menuCoverWidth: this.getInitialMenuCoverWidth(),
        courses: [],
        isContactVisible: false,
        loading: false,
        destination : "",
        trigger : 0
    }
    getInitialMenuCoverWidth() {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.fetchCourses();

        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);

                if (user && user.role === 'student') {
                    window.location.href = '/online_prerecorded';
                } else {
                    console.log("User is not a student or user data is incomplete.");
                }

            } catch (error) {
                console.error("Error parsing user data:", error);
                localStorage.removeItem('user');
                window.location.href = '/login'; // Redirect to login on error
            }
        }



    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            this.setState({ menuCoverWidth: menuCover.offsetWidth });
        }
        this.setState({ windowHeight: window.innerHeight - 60 });
    };

    fetchCourses = async () => {
        this.setState({loading: true})
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/courses/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ courses: response.data , loading : false});
            console.log("API Response:", response.data);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/";
            } else {
                console.error("Error fetching data:", error);
            }
            this.setState({loading : false})
        }
    };
    initialfilterbytype = () => {
        const courses = this.state.courses;
        if (this.state.filter_type_name === "Type" || this.state.filter_type_name === "All") {
            return courses
        } else {
            return courses.filter((item) => item.labels === this.state.filter_type_name);

        }
    };

    initialfilterbylevel = () => {
        const courses = this.initialfilterbytype();

        if (this.state.filter_level_name === "Level" || this.state.filter_level_name === "All") {
            return courses
        } else if (this.state.filter_level_name === "Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Advance" ||
                    item.tags === "Professional"
            );
        } else if (this.state.filter_level_name === "Beginner to Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Beginner to Advance" ||
                    item.tags === "Beginner to Professional"
            );
        }

        else {
            return courses.filter((item) => item.tags === this.state.filter_level_name);

        }
    };
    initialfilterbystatus = () => {
        const courses = this.initialfilterbylevel();
        if (this.state.filter_status_name === "Status" || this.state.filter_status_name === "All") {
            return courses
        } else if (this.state.filter_status_name === "Online") {
            return courses.filter(
                (item) =>
                    item.training_type === "Online Prerecorded" ||
                    item.training_type === "Online Live with Facilitator"
            );
        }
        // If "Physical" is selected, filter for "general physical class" and "private physical class"
        else if (this.state.filter_status_name === "Physical") {
            return courses.filter(
                (item) =>
                    item.training_type === "General Physical Class" ||
                    item.training_type === "Physical Private Class"
            );
        }
        // Default case: If filter_level_name matches a specific training_type directly
        else {
            return courses.filter(
                (item) => item.training_type === this.state.filter_status_name
            );
        }
    };
    handleFilterChange = (filterType, filterLevel, filterStatus) => {
        this.setState({
            filter_type_name: filterType,
            filter_level_name: filterLevel,
            filter_status_name: filterStatus,
        })
    };


    handleRefresh = () => {
        this.setState({
            filter_type_name: "Type",
            selectedItem: "",
            filter_level_name: "Level",
            selectedItems: "",
            filter_status_name: "Status",
            selectedIteme: ""
        }, () => {
            // Important: Call the reset on the child!
            this.filterRef.handleReset(); // Assuming you add a ref to the FilterCourse component
        })
    }



    handleNavigation = (dest) =>{
        this.setState({
            destination: dest,
            trigger : 1
        })
    }



    render() {
        const { menuCoverWidth, trigger, destination } = this.state;
        const filteredCourses = this.initialfilterbystatus()
        const courselist = filteredCourses.length > 0 ? filteredCourses.map((info, index) => {
            return (
                <tr key={info.id}>
                    <td className="sn">{index + 1}</td>
                    <td>{info.title}</td>
                    <td>{info.training_type}</td>
                    <td>{info.tags}</td>
                    <td>{info.labels}</td>
                    <td>{info.price}</td>
                    <td className="delete"><button className="delete-button" style={{ backgroundColor: "green" }} onClick={() => this.handleNavigation(`/tutor_course_edit/${info.id}`)}>Edit Course</button></td>
                    <td className="delete" ><Link to={`/tutor_description/${info.id}`}><button className="delete-button" style={{ backgroundColor: "rgb(0,0,0,0)", color: "rgba(0, 0, 0, 0.8)", width: "150px" }} >View Course</button></Link></td>
                </tr>

            )
        }) : (
            <tr className="course_list_empty">
                <td>Loading ......</td>
            </tr>
        )



        return (
            <div className="dashboard">
                <DashSearchHeader onResize={this.handleResize} />
                <TutorDashMenu />
                <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 10px)`, overflow: 'hidden' }}>
                    <div className="course_head" >
                        <h2> Courses <Link to="/tutor_course_edit"><button>Add Course</button></Link></h2>
                        <FilterCourse
                            filterType={this.state.filter_type_name} // Pass current values as props
                            filterLevel={this.state.filter_level_name}
                            filterStatus={this.state.filter_status_name}
                            onFilterChange={this.handleFilterChange}
                            ref={(el) => this.filterRef = el}
                        />
                    </div>
                    <div className="course_body">
                        <div className="course_body_cover">

                            {filteredCourses.length > 1 ?
                                < div className="table">
                                    <table className="librarytable">
                                        <thead>
                                            <tr>
                                                <th className="sn">S/N</th>
                                                <th className="course">Course Title</th>
                                                <th>Training Type</th>
                                                <th>Tag</th>
                                                <th>Label</th>
                                                <th>Price</th>
                                                <th className="delete">Edit</th>
                                                <th className="delete">View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {courselist}
                                        </tbody>
                                    </table>
                                </div> :
                                <div className="course_list_empty">
                                    <img src={Empty} alt="not avaialable" /><br />
                                    <h5>No available course <br />with that specification.</h5>
                                    <button onClick={this.handleRefresh}>Reset Filter</button>
                                </div>
                            }


                        </div>
                    </div>
                    <FooterDashboard />
                    <Policy />
                </div>
                {this.state.loading ? <LoadingError /> : null}
                <Navigate destination={destination} trigger={trigger}/>
            </div >
        )
    }
}

export default TutorCourses